export const CANVAS_SIZE = {width: 800, height: 600}

export const FONT = { fontSize: '16px', fill: '#000' }

export const smaller = { ...FONT, fontSize: '10px'}
export const larger = { ...FONT, fontSize: '28px'}
export const lighter = {...FONT, fill: '#ccc'}
export const light_smaller = {...FONT, fontSize: '10px', fill: '#ccc'}

export const COLOUR_SELECTED = 0xdbb47f